import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

var customActions = {
  exportExcel: { method: 'GET', url: 'export/excel', responseType: 'blob' }
}

export const ExportResource = () => {
  return Vue.resource('export/questionnaires', {}, customActions)
}



// WEBPACK FOOTER //
// ./src/api/export.js